module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "project-update"
  }, [_c('div', {
    staticClass: "wizard-toolbar"
  }, [_c('div', {
    staticClass: "grid-2"
  }, [_c('div', {
    staticClass: "progress-step-1 active"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step1-title")))])]), _vm._v(" "), _c('div', {
    staticClass: "progress-step-2 inactive"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step2-title")))])])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("ui.project_wizard.step1-title")))]), _vm._v(" "), _c('form', {
    staticClass: "project-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "required": true,
      "model": "project",
      "name": "name",
      "placeholder": "Tech con 2016"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions wizard-footer"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("ui.global.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat btn-save",
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("ui.pages.project-next-button")) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c8802c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/wizard/StepOne.vue
// module id = 1942
// module chunks = 0